<!--Slideshow banner start-->
<div class="uk-position-relative uk-visible-toggle uk-background-cover " tabindex="-1"
  uk-slideshow="min-height: 420;  autoplay: true; autoplay-interval: 2200; max-height: 500; ">
  <ul class="uk-slideshow-items ">
    <li>
      <img src="assets/Homepagebanner.png" alt="" uk-cover>
      <div class="uk-position-left uk-position-small uk-text-center uk-light">
        <div class="uk-section uk-padding">

          <div class="uk-container uk-width-2xlarge" style="padding-top: 40px;">
            <h1 class="uk-text-bold uk-text-left" style="margin-bottom:10px">A choice that makes the difference</h1>

            <h5 class="uk-text-bold uk-text-left" style="margin-top:10px">
              Fueling happiness for our clients come & join with us We deliver personalized technology solutions to
              delight your customers and accelerate business growth.</h5>
          </div>
        </div>
      </div>
    </li>
    <li>
      <img src="assets/homeee1.png" alt="banner" uk-cover>
      <div class="uk-position-left uk-position-small uk-text-center uk-light">
        <div class="uk-section uk-padding">

          <div class="uk-container uk-width-2xlarge" style="padding-top: 60px;">
            <h1 class="uk-text-bold uk-text-left" style="margin-bottom:10px">Mobile Application Development</h1>

            <h5 class="uk-text-bold uk-text-left" style="margin-top:10px">
              Our developers craft the finest cross-platform apps for iOS and Android in an accelerated time frame.</h5>
          </div>
        </div>
      </div>
    </li>
    <li>
      <img src="assets/homeee2.png" alt="banner" uk-cover>
      <div class="uk-position-left uk-position-small uk-text-center uk-light">
        <div class="uk-section uk-padding">
          <div class="uk-container uk-width-2xlarge" style="padding-top: 40px;">
            <h1 class="uk-text-bold uk-text-left" style="margin-bottom:10px">Join Us!</h1>

            <h5 class="uk-text-bold uk-text-left" style="margin-top:10px">
              "Teamwork is the ability to work together toward a common vision. The ability to direct individual
              accomplishments toward organizational objectives. It is the fuel that allows common people to attain
              uncommon results."</h5>
          </div>
        </div>
      </div>
    </li>
    <li>
      <img src="assets/homeee3.png" alt="banner" uk-cover>
      <div class="uk-position-left uk-position-small uk-text-center uk-light">
        <div class="uk-section uk-padding">
          <div class="uk-container uk-width-2xlarge" style="padding-top: 60px;">
            <h1 class="uk-text-bold uk-text-left" style="margin-bottom:10px">Website Development <br>Services </h1>

            <h5 class="uk-text-bold uk-text-left" style="margin-top:10px">Release the potential of the web. Custom web
              applications created to reach particular marketing requests</h5>
          </div>
        </div>
      </div>
    </li>
  </ul>
  <div class="uk-light">
    <a class="uk-position-center-left uk-position-small uk-hidden-hover" href="#" uk-slidenav-previous
      uk-slideshow-item="previous"></a>
    <a class="uk-position-center-right uk-position-small uk-hidden-hover" href="#" uk-slidenav-next
      uk-slideshow-item="next"></a>
  </div>
</div>
<!--slide show Banner Ends-->
<!--about company section-->
<div class="uk-section" style="padding-top: 0px; padding-bottom: 20px;">
  <div class="uk-container uk-container-expand con ">
    <br>
    <h2 class="uk-text-center" style="color:	black; font-weight:600"><span>Who We Are </span></h2>
    <p class="uk-text-medium uk-text-justify" style="font-size: 18px;">
      We work with you to design your future. To make it better. To let you wield the power to tame technology
      disruptions. Our application development service gives your applications the power of new technologies to make it
      future proof. Our technical expertise, domain insights and design-centric approach help us to create applications
      that enhance your business value. Our applications set the quality standard a notch higher
      with proven development methodologies under low-cost overheads.
    </p>


    <div class="uk-child-width-1-3@s uk-grid-match " uk-grid>
      <div>
        <div class="uk-card uk-card-muted  uk-card-body ">
          <p class="uk-text-center"><img src="assets/homesm.png" width=35% height=35%></p>
          <h3 class="uk-card-title" style="color:	black;">Result Driven Solutions </h3>
          <p class="uk-text-justify " style="word-spacing: -2px;letter-spacing:1px ;">
            We are a team of prominent website design company.
            We bring in the right mix of technology and industry expertise to achieve your business needs to support
            your business to improve performance and productivity by solving problems.
          </p>
        </div>
      </div>
      <div>
        <div class="uk-card uk-card-muted  uk-card-body">
          <p class="uk-text-center"><img src="assets/homeag.png" width=35% height=35%></p>
          <h3 class="uk-card-title" style="color:	black;">Agile Culture</h3>
          <p class="uk-text-medium uk-text-justify" style="word-spacing: -1px;letter-spacing:1px ;">
            We help you innovate quickly with our agile methodologies and procedures more on finding the best way to
            solve a problem rather than applying the same procedural approach to every situation. Trust forms the basis
            of any relationship.
          </p>
        </div>
      </div>
      <div>
        <div class="uk-card uk-card-muted  uk-card-body">
          <p class="uk-text-center"><img src="assets/homesc.png" width=45% height=45%></p>
          <h3 class="uk-card-title" style="color:	black;">Passionate team of growing developers</h3>
          <p class="uk-text-medium uk-text-justify" style="word-spacing: -1px;letter-spacing:1px ;">We are the group of
            employees for your business through cutting-edge applications. Our team can easily slip into disorder or
            simply resentment for you as you break promises, forget what matters to.</p>
        </div>
      </div>
    </div>
  </div>
</div>
<!--ends about company section-->

<!--Service section start-->
<div class="uk-section" >
  <div class="uk-container uk-container-expand" style="padding-bottom: 0px;">
    <h2 class="uk-text-center">Our Main Core Services</h2>
    <p class=" uk-text-left" style="font-size: 18px;">WebSoulLabs provides digital conversion services to drive their
      traditional applications to advanced technologies, thereby increasing productivity. We offer a broad collection of
      technology services to accelerate your business growth.</p>
    <br>
    <div class="uk-grid-match uk-child-width-1-4@s " uk-grid>
      <div class="uk-animation-toggle" tabindex="0">
<div>
        <div class="uk-card uk-card-default uk-card-body uk-card-small uk-animation-scale-up">
          <img class="uk-align-center" src="assets/homemob.png" width="90" height="90" alt="">
          <h3 class="uk-card-title uk-text-center">Mob App Development </h3>

          <p class="uk-text-justify">WebSoulLabs is the most trusted app developers in Kerala. We design and build high
            quality, custom mobile apps with attractive and functional user interfaces with maximum working efficiency
            guaranteed by our team.</p>
          <a href="mobile-application-development-page">Read More</a>

</div>

        </div>
      </div>

      <div class="uk-animation-toggle" tabindex="0">


        <div>
          <div class="uk-card uk-card-default uk-card-small  uk-card-body uk-animation-scale-up">
            <img class="uk-align-center" src="assets/images.png" width="90" height="90" alt="">
            <h3 class="uk-card-title uk-text-center">Web App Development service</h3>

            <p class="uk-text-justify">WebSoulLabs have a team of well experienced and skilled developers with latest website building technologies to provide you the best service. We work on your company’s goals and objectives for website development.</p>
            <a href="web">Read More</a>
          </div>

        </div>
      </div>

      <div class="uk-animation-toggle" tabindex="0">



        <div>
          <div class="uk-card uk-card-default uk-card-small  uk-card-body uk-animation-scale-up">
            <img class="uk-align-center" src="assets/imagecart.png" width="90" height="90" alt="">
            <h3 class="uk-card-title uk-text-center">E-commerce App Development</h3>

            <p class="uk-text-justify" style="word-spacing:1px;letter-spacing:-1px">Delivering ideas into pleasing
              customer experiences through digital services. We let your products to reach a wider circle. With our
              Ecommerce development solution, you can explore limitless Innovate and Grow your business.</p>
            <a href="ecommerce-page">Read More</a>
          </div>
        </div>
          <!-- </div> -->
        </div>
        <div class="uk-animation-toggle" tabindex="0">
          <div class="uk-card uk-card-default uk-card-body uk-card-small uk-animation-scale-up">
            <img class="uk-align-center" src="assets/homedig.png" width="90" height="90" alt="">
            <h3 class="uk-card-title uk-text-center">Digital marketing service</h3>




            <p class="uk-text-justify">Creating an online powerful impact on all digital media at the right time to the
              right customers. We will help you to figure out how to market your business online. For a unique digital
              brand identity to securing a favourite digital spot. </p>
            <a href="digital-mart-page">Read More</a>
          </div>

        </div>
      </div>

    </div>

  </div>


<!--End service section-->

<br>
<!--start of how we works-->

<div class="uk-section">
  <div class="uk-container">

    <h2 class="uk-text-center" style="font-weight: 600;">How We Work</h2>
    <p class=" uk-text-center uk-text-justify" style="font-size: 18px;">We ideate, design, and create web & mobile
      applications with an emphasis on the latest technologies and trends. Although the business needs may differ from
      one enterprise to another, our dedication and iterative planning towards achieving business growth are forever
      unaltered.</p>
  </div>
  <br>

  <div class="uk-grid-collapse uk-child-width-1-2@s uk-child-width-1-4@m uk-text-center uk-grid-match " uk-grid>
    <div>
      <div class="uk-card uk-card-default uk-light " style=" background-color: #008080">
        <h1 class="uk-text-justify-left"><b>1</b></h1>
        <h3 style="margin-top: 0px;">Requirement Analysis</h3>
        <p class=" uk-text-justify uk-margin-left uk-margin-right">Requirement analysis process ensures that there is no
          confusion regarding what you require, the kind of features you need and quality you expect from the company.
        </p>
        <br>
      </div>
    </div>
    <div>
      <div class="uk-card uk-card-default uk-light" style="color: white; background-color: #20B2AA">
        <h1><b>2</b></h1>
        <h3 style="margin-top: 0px;">Planing & Wire-Framing</h3>
        <p class=" uk-text-justify uk-margin-left uk-margin-right">The skeleton plan of a website can be broken down
          into three components: information design, navigation design, and interface design. Page layout is where these
          components come together.</p>
        <br>
      </div>
    </div>
    <div>
      <div class="uk-card uk-card-default uk-light" style="color: white; background-color: #808080">
        <h1><b>3</b></h1>
        <h3 style="margin-top: 0px;">UI Design & Prototyping</h3>
        <p class=" uk-text-justify uk-margin-left uk-margin-right">The website prototype can be any mock-up or demo of
          what a website look like. It gives the customer a complete idea of how the site will look like in the final
          result. </p>
        <br>
      </div>
    </div>
    <div>
      <div class="uk-card uk-card-default uk-light" style="color: white; background-color: #DDA0DD">
        <h1><b>4</b></h1>
        <h3 style="margin-top: 0px;">Coding & Development</h3>
        <p class=" uk-text-justify uk-margin-left uk-margin-right">Web programming, also known as web development, is
          the creation of dynamic web applications. Web development also uses computer code to create user-facing
          software. </p>
        <br>
      </div>
    </div>

  </div>
  <BR>
  <div class="uk-grid-collapse uk-child-width-1-2@s uk-child-width-1-4@m uk-text-center uk-grid-match" uk-grid>
    <div>
      <div class="uk-card uk-card-default uk-light" style="color: white; background-color: #BC8F8F">
        <h1 class="uk-text-justify-left"><b>5</b></h1>
        <h3 style="margin-top: 0px;">Unit Testing</h3>
        <p class=" uk-text-justify uk-margin-left uk-margin-right">Our proficient testers help startups/ development
          companies bring to market quicker, enhance user experience and launch apps with enthusiasm. We test Mobile
          Apps, Web Apps. Reduces Cost of Testing defects captured in early phase.</p>
        <br>
      </div>
    </div>
    <div>
      <div class="uk-card uk-card-default  uk-light" style="color: white; background-color: #FFA07A">
        <h1><b>6</b></h1>
        <h3 style="margin-top: 0px;">Guided Acceptance Testing</h3>
        <p class=" uk-text-justify uk-margin-left uk-margin-right">Our squad is specialized in all testing apps and
          delivers the good quality test automation frameworks. is handed over to the user in order to find out if the
          software meets the user expectations and works as it is expected to.</p>
        <br>
      </div>
    </div>
    <div>
      <div class="uk-card uk-card-default uk-light" style="color: white; background-color: #F08080">
        <h1><b>7</b></h1>
        <h3 style="margin-top: 0px;">Release & Implementaion</h3>
        <p class=" uk-text-justify uk-margin-left uk-margin-right">The release procedure encompasses planning, design,
          build, configuration and testing of hardware and software releases to develop a detailed release technique. We
          provide support for the deployment. </p>
        <br>
      </div>
    </div>
    <div>
      <div class="uk-card uk-card-default uk-light" style="color: white; background-color: #8FBC8F">
        <h1><b>8</b></h1>
        <h3 style="margin-top: 0px;">Traning & Support</h3>
        <p class=" uk-text-justify uk-margin-left uk-margin-right">Apart from software development services, entire
          support services to your satisfaction. We deliver real-time software supervision and support service for all
          our clients to fix all the technical issues.</p>
        <br>
      </div>
    </div>
  </div>
</div>


<!--end of how we work-->

<div class="uk-container uk-margin-large">

  <ul class="uk-subnav uk-subnav-pill uk-flex-center " uk-switcher="media: @s">

    <li class="uk-active tab-item"><a class="tab" href="#">Mobile Application</a></li>
    <li class="tab-item"><a class="tab" href="#">Web Application</a></li>
    <li class="tab-item"><a class="tab" href="#">Ecommerce Application</a></li>
    <li class="tab-item"><a class="tab" href="#">Digital Marketing</a></li>
  </ul>
  <!--start of mob app development tab-->
  <ul class="uk-switcher uk-margin-large">
    <li>
      <div class="uk-child-width-1-4@m uk-grid-match" uk-grid>
        <div>
          <div class="uk-card uk-card-small "
            style="box-shadow: 0 .125rem .25rem rgba(0,0,0,.075)!important; border: 1px solid #dee2e6!important;">
            <div class="uk-card-media-top uk-text-center uk-padding-small">
              <div class="uk-animation-toggle" tabindex="0">
                <img class="uk-animation-slide-top-small" src="assets/homeiphone.png" width="40%" height="40%" alt="">
              </div>
            </div>
            <div class="uk-card-body">
              <h4 class="uk-card-title uk-text-center">iPhone App Development Services</h4>


              <p class="uk-text-center uk-text-justify">Applications that are designed and developed to run on Apple IOS
                operating system including iPhones, iPads and iPod touch devices is called iPhone App development.</p>


            </div>
          </div>
        </div>
        <div>
          <div class="uk-card uk-card-small"
            style="box-shadow: 0 .125rem .25rem rgba(0,0,0,.075)!important; border: 1px solid #dee2e6!important;">
            <div class="uk-card-media-top uk-text-center uk-padding-small">
              <div class="uk-animation-toggle" tabindex="0">
                <img class="uk-animation-slide-top-small" src="assets/homeandroid.png" width="40%" height="40%" alt="">
              </div>
            </div>
            <div class="uk-card-body">
              <h4 class="uk-card-title uk-text-center">Android App Development Services</h4>


              <p class="uk-text-center uk-text-justify">Android software development is the process by which
                applications are created for devices. Java, XML are the two programming languages used in Android.</p>


            </div>
          </div>
        </div>
        <div>
          <div class="uk-card uk-card-small"
            style="box-shadow: 0 .125rem .25rem rgba(0,0,0,.075)!important; border: 1px solid #dee2e6!important;">
            <div class="uk-card-media-top uk-text-center uk-padding-small">
              <div class="uk-animation-toggle" tabindex="0">
                <img class="uk-animation-slide-top-small" src="assets/homewear.jpg" width="40%" height="40%" alt="">
              </div>
            </div>
            <div class="uk-card-body">
              <h4 class="uk-card-title uk-text-center">Wearable App Development Services</h4>


              <p class="uk-text-center uk-text-justify">Wear OS apps run directly on a watch, giving you access to
                hardware such as sensors and the GPU. Wearable apps are similar to other apps that use the Android SDK.
              </p>


            </div>
          </div>
        </div>
        <div>
          <div class="uk-card uk-card-small"
            style="box-shadow: 0 .125rem .25rem rgba(0,0,0,.075)!important; border: 1px solid #dee2e6!important;">
            <div class="uk-card-media-top uk-text-center uk-padding-small">
              <div class="uk-animation-toggle" tabindex="0">
                <img class="uk-animation-slide-top-small" src="assets/homeibeacon.svg" width="40%" height="40%" alt="">
              </div>
            </div>
            <div class="uk-card-body">
              <h4 class="uk-card-title uk-text-center">iBeacon App Development Services</h4>


              <p class="uk-text-center uk-text-justify">IBeacon is implementation of BLE technology standard, which
                enables Mobile Apps to receive signals from beacons and exchange information within short distances.</p>


            </div>
          </div>
        </div>
        <div>
          <div class="uk-card uk-card-small"
            style="box-shadow: 0 .125rem .25rem rgba(0,0,0,.075)!important; border: 1px solid #dee2e6!important;">
            <div class="uk-card-media-top uk-text-center uk-padding-small">
              <div class="uk-animation-toggle" tabindex="0">
                <img class="uk-animation-slide-top-small" src="assets/homeinteractive.png" width="40%" height="40%"
                  alt="">
              </div>
            </div>
            <div class="uk-card-body">
              <h4 class="uk-card-title uk-text-center">Interactive TV App Development Services</h4>


              <p class="uk-text-center uk-text-justify">Interactive TV Application is a kind of software installed in
                any computerized device that can be easily used and manipulated by the user.</p>


            </div>
          </div>
        </div>
        <div>
          <div class="uk-card uk-card-small"
            style="box-shadow: 0 .125rem .25rem rgba(0,0,0,.075)!important; border: 1px solid #dee2e6!important;">
            <div class="uk-card-media-top uk-text-center uk-padding-small">
              <div class="uk-animation-toggle" tabindex="0">
                <img class="uk-animation-slide-top-small" src="assets/homecross.png" width="48%" height="48%" alt="">
              </div>
            </div>
            <div class="uk-card-body">
              <h4 class="uk-card-title uk-text-center">Cross Platform Development Services</h4>

              <p class="uk-text-center uk-text-justify">Cross-platform is an application frameworks for development
                allow developers to create mobile applications that are platform independent. </p>


            </div>
          </div>
        </div>
        <div>
          <div class="uk-card uk-card-small"
            style="box-shadow: 0 .125rem .25rem rgba(0,0,0,.075)!important; border: 1px solid #dee2e6!important;">
            <div class="uk-card-media-top uk-text-center uk-padding-small">
              <div class="uk-animation-toggle" tabindex="0">
                <img class="uk-animation-slide-top-small" src="assets/swift.jpg" width="30%" height="30%" alt="">
              </div>
            </div>
            <div class="uk-card-body">
              <h4 class="uk-card-title uk-text-center">Swift App Development Services</h4>


              <p class="uk-text-center uk-text-justify">Swift app offers certain speed advantages of during iOS
                application development . Swift is faster, safer, and enables a level.</p>


            </div>
          </div>
        </div>
        <div>
          <div class="uk-card uk-card-small"
            style="box-shadow: 0 .125rem .25rem rgba(0,0,0,.075)!important; border: 1px solid #dee2e6!important;">
            <div class="uk-card-media-top uk-text-center uk-padding-small">
              <div class="uk-animation-toggle" tabindex="0">
                <img class="uk-animation-slide-top-small" src="assets/xamarin.png" width="29%" height="29%" alt="">
              </div>
            </div>
            <div class="uk-card-body">
              <h4 class="uk-card-title uk-text-center">Xamerin App Development Services</h4>


              <p class="uk-text-center uk-text-justify">Xamarin is an open-source platform for building modern and
                performant applications for iOS, Android, and Windows with. </p>


            </div>
          </div>
        </div>
      </div>
    </li>
    <!--end of mobile app develpoment tab-->
    <!--start of web app ddevelopment tab-->
    <li>
      <div class="uk-child-width-1-4@m uk-grid-match" uk-grid>
        <div>
          <div class="uk-card uk-card-small"
            style="box-shadow: 0 .125rem .25rem rgba(0,0,0,.075)!important; border: 1px solid #dee2e6!important;">
            <div class="uk-card-media-top uk-text-center uk-padding-small">
              <div class="uk-animation-toggle" tabindex="0">
                <img class="uk-animation-slide-top-small" src="assets/homephp.png" width="40%" height="40%" alt="">
              </div>
            </div>
            <div class="uk-card-body">
              <h4 class="uk-card-title uk-text-center">PHP Web Development Services</h4>
              <p class="uk-text-left">We provide PHP development outcomes that are quick, responsive, creative.
                Associating the capability of PHP interactive websites.</p>

            </div>
          </div>
        </div>
        <div>
          <div class="uk-card uk-card-small"
            style="box-shadow: 0 .125rem .25rem rgba(0,0,0,.075)!important; border: 1px solid #dee2e6!important;">
            <div class="uk-card-media-top uk-text-center uk-padding-small">
              <div class="uk-animation-toggle" tabindex="0">
                <img class="uk-animation-slide-top-small" src="assets/homecake.png" width="40%" height="40%" alt="">
              </div>
            </div>
            <div class="uk-card-body">
              <h4 class="uk-card-title uk-text-center">Cake PHP Development Services</h4>
              <p class="uk-text-left">We provide CakePHP it follows the most model–view–controller approach and is
                written in PHP, modeled after the concepts of Ruby on Rails.
              </p>

            </div>
          </div>
        </div>
        <div>
          <div class="uk-card uk-card-small"
            style="box-shadow: 0 .125rem .25rem rgba(0,0,0,.075)!important; border: 1px solid #dee2e6!important;">
            <div class="uk-card-media-top uk-text-center uk-padding-small">
              <div class="uk-animation-toggle" tabindex="0">
                <img class="uk-animation-slide-top-small" src="assets/homelaravel.png" width="40%" height="40%" alt="">
              </div>
            </div>
            <div class="uk-card-body">
              <h4 class="uk-card-title uk-text-center">Laravel web Development Services</h4>
              <p class="uk-text-left">WebSoulLabs has brilliant and powerful developers who are highly experienced in
                the Laravel framework. Using Laravel,creative web apps. </p>

            </div>
          </div>
        </div>
        <div>
          <div class="uk-card uk-card-small"
            style="box-shadow: 0 .125rem .25rem rgba(0,0,0,.075)!important; border: 1px solid #dee2e6!important;">
            <div class="uk-card-media-top uk-text-center uk-padding-small">
              <div class="uk-animation-toggle" tabindex="0">
                <img class="uk-animation-slide-top-small" src="assets/homepython.png" width="40%" height="40%" alt="">
              </div>
            </div>
            <div class="uk-card-body">
              <h4 class="uk-card-title uk-text-center">Python web Development Services</h4>
              <p class="uk-text-left">We are a top-notch Python Web Development Company & our talented experts provide
                steady user experience by keeping in sense the business regulations.</p>

            </div>
          </div>
        </div>
        <div>
          <div class="uk-card uk-card-small"
            style="box-shadow: 0 .125rem .25rem rgba(0,0,0,.075)!important; border: 1px solid #dee2e6!important;">
            <div class="uk-card-media-top uk-text-center uk-padding-small">
              <div class="uk-animation-toggle" tabindex="0">
                <img class="uk-animation-slide-top-small" src="assets/homeword.png" width="40%" height="40%" alt="">
              </div>
            </div>
            <div class="uk-card-body">
              <h4 class="uk-card-title uk-text-center">Wordpress web Development Services</h4>
              <p class="uk-text-left">We will create your WordPress website and you will be glad to have us on-site. We
                build from scratch and create elegant and responsive websites to run excessive traffic. </p>

            </div>
          </div>
        </div>
        <div>
          <div class="uk-card uk-card-small"
            style="box-shadow: 0 .125rem .25rem rgba(0,0,0,.075)!important; border: 1px solid #dee2e6!important;">
            <div class="uk-card-media-top uk-text-center uk-padding-small">
              <div class="uk-animation-toggle" tabindex="0">
                <img class="uk-animation-slide-top-small" src="assets/homemysql.png" width="40%" height="40%" alt="">
              </div>
            </div>
            <div class="uk-card-body">
              <h4 class="uk-card-title uk-text-center">Mysql web Development Services</h4>
              <p class="uk-text-left">We provide detailed MySQL development services from development to integration,
                migration and auditing and optimization of the MySQL databases.</p>

            </div>
          </div>
        </div>
        <div>
          <div class="uk-card uk-card-small"
            style="box-shadow: 0 .125rem .25rem rgba(0,0,0,.075)!important; border: 1px solid #dee2e6!important;">
            <div class="uk-card-media-top uk-text-center uk-padding-small">
              <div class="uk-animation-toggle" tabindex="0">
                <img class="uk-animation-slide-top-small" src="assets/homecustom.png" width="40%" height="40%" alt="">
              </div>
            </div>
            <div class="uk-card-body">
              <h4 class="uk-card-title uk-text-center">Customised Business Application</h4>
              <p class="uk-text-left">WebSoulLabs has a broad experience in custom business applications development. We
                deliver the creative custom application and development services .</p>

            </div>
          </div>
        </div>
        <div>
          <div class="uk-card uk-card-small"
            style="box-shadow: 0 .125rem .25rem rgba(0,0,0,.075)!important; border: 1px solid #dee2e6!important;">
            <div class="uk-card-media-top uk-text-center uk-padding-small">
              <div class="uk-animation-toggle" tabindex="0">
                <img class="uk-animation-slide-top-small" src="assets/homeweb.png" width="40%" height="40%" alt="">
              </div>
            </div>
            <div class="uk-card-body">
              <h4 class="uk-card-title uk-text-center">Web Design and Development</h4>
              <p class="uk-text-left">Our squad of skilled website developers and experienced digital marketing experts
                use the latest technologies and verified techniques to develop user employing. </p>

            </div>
          </div>
        </div>
      </div>
    </li>
    <!--End of web tab-->
    <!--start of ecommerce tab-->
    <li>
      <div class="uk-child-width-1-4@m uk-grid-match" uk-grid>
        <div>
          <div class="uk-card uk-card-small"
            style="box-shadow: 0 .125rem .25rem rgba(0,0,0,.075)!important; border: 1px solid #dee2e6!important;">
            <div class="uk-card-media-top uk-text-center uk-padding-small">
              <div class="uk-animation-toggle" tabindex="0">
                <img class="uk-animation-slide-top-small" src="assets/homemang.webp" width="40%" height="40%" alt="">
              </div>
            </div>
            <div class="uk-card-body">
              <h4 class="uk-card-title uk-text-center">Magento E-Commerce Services</h4>
              <p class="uk-text-left">Magento is the platform to built on open source technology which provides online
                merchants flexible. </p>

            </div>
          </div>
        </div>
        <div>
          <div class="uk-card uk-card-small"
            style="box-shadow: 0 .125rem .25rem rgba(0,0,0,.075)!important; border: 1px solid #dee2e6!important;">
            <div class="uk-card-media-top uk-text-center uk-padding-small">
              <div class="uk-animation-toggle" tabindex="0">
                <img class="uk-animation-slide-top-small" src="assets/homeshop.png" width="40%" height="40%" alt="">
              </div>
            </div>
            <div class="uk-card-body">
              <h4 class="uk-card-title uk-text-center">Shopify E-Commerce Services</h4>
              <p class="uk-text-left">Shopify is the best ecommerce platform .Service is designed to build their own,
                scalable online store with hundred .</p>
            </div>
          </div>
        </div>
        <div>
          <div class="uk-card uk-card-small"
            style="box-shadow: 0 .125rem .25rem rgba(0,0,0,.075)!important; border: 1px solid #dee2e6!important;">
            <div class="uk-card-media-top uk-text-center uk-padding-small">
              <div class="uk-animation-toggle" tabindex="0">
                <img class="uk-animation-slide-top-small" src="assets/homeecom.png" width="40%" height="40%" alt="">
              </div>
            </div>
            <div class="uk-card-body">
              <h4 class="uk-card-title uk-text-center">Woo Commerce E-Commerce Services</h4>
              <p class="uk-text-left">Woo Commerce E-Commerce Services is the customizable, open-source of E-Commerce
                platform to built on Word Press.</p>

            </div>
          </div>
        </div>
        <div>
          <div class="uk-card uk-card-small"
            style="box-shadow: 0 .125rem .25rem rgba(0,0,0,.075)!important; border: 1px solid #dee2e6!important;">
            <div class="uk-card-media-top uk-text-center uk-padding-small">
              <div class="uk-animation-toggle" tabindex="0">
                <img class="uk-animation-slide-top-small" src="assets/homecart.jpg" width="40%" height="40%" alt="">
              </div>
            </div>
            <div class="uk-card-body">
              <h4 class="uk-card-title uk-text-center">Open Cart E-Commerce Services</h4>
              <p class="uk-text-left">Open Cart is a complete E-Commerce solution that lets you launch your online
                store, add/manage your products.</p>

            </div>
          </div>
        </div>
        <div>
          <div class="uk-card uk-card-small"
            style="box-shadow: 0 .125rem .25rem rgba(0,0,0,.075)!important; border: 1px solid #dee2e6!important;">
            <div class="uk-card-media-top uk-text-center uk-padding-small">
              <div class="uk-animation-toggle" tabindex="0">
                <img class="uk-animation-slide-top-small" src="assets/homebrain.png" width="40%" height="40%" alt="">
              </div>
            </div>
            <div class="uk-card-body">
              <h4 class="uk-card-title uk-text-center">Braintree Payment Gateway Services</h4>
              <p class="uk-text-left">Braintree is the full-stack payments platform that makes it easy to accept
                payments in your app or website.</p>

            </div>
          </div>
        </div>
        <div>
          <div class="uk-card uk-card-small"
            style="box-shadow: 0 .125rem .25rem rgba(0,0,0,.075)!important; border: 1px solid #dee2e6!important;">
            <div class="uk-card-media-top uk-text-center uk-padding-small">
              <div class="uk-animation-toggle" tabindex="0">
                <img class="uk-animation-slide-top-small" src="assets/homestripe.png" width="41%" height="41%" alt="">
              </div>
            </div>
            <div class="uk-card-body">
              <h4 class="uk-card-title uk-text-center">Stripe Payment Gateway Services</h4>
              <p class="uk-text-left">Stripe is a complete solution that combines the functionality of a merchant
                account and a gateway in one. </p>
            </div>
          </div>
        </div>
        <div>
          <div class="uk-card uk-card-small"
            style="box-shadow: 0 .125rem .25rem rgba(0,0,0,.075)!important; border: 1px solid #dee2e6!important;">
            <div class="uk-card-media-top uk-text-center uk-padding-small">
              <div class="uk-animation-toggle" tabindex="0">
                <img class="uk-animation-slide-top-small" src="assets/homepay.jpg" width="72%" height="72%" alt="">
              </div>
            </div>
            <div class="uk-card-body">
              <h4 class="uk-card-title uk-text-center">PayFort Payment Gateway Services</h4>
              <p class="uk-text-left">Payfort payment increase the frequency of transactions while offering recurring
                service for auto-schedule payments.</p>

            </div>
          </div>
        </div>
        <div>
          <div class="uk-card uk-card-small"
            style="box-shadow: 0 .125rem .25rem rgba(0,0,0,.075)!important; border: 1px solid #dee2e6!important;">
            <div class="uk-card-media-top uk-text-center uk-padding-small">
              <div class="uk-animation-toggle" tabindex="0">
                <img class="uk-animation-slide-top-small" src="assets/homespark.png" width="40%" height="40%" alt="">
              </div>
            </div>
            <div class="uk-card-body">
              <h4 class="uk-card-title uk-text-center">Sparkpost Payment Gateway Services</h4>
              <p class="uk-text-left">The world’s most sophisticated senders rely on Spark Post to deliver billions of
                emails every day.</p>

            </div>
          </div>
        </div>
      </div>
    </li>
    <!--end of ecom-->
    <!--start of digital marketing-->
    <li>
      <div class="uk-child-width-1-4@m uk-grid-match" uk-grid>
        <div>
          <div class="uk-card uk-card-small"
            style="box-shadow: 0 .125rem .25rem rgba(0,0,0,.075)!important; border: 1px solid #dee2e6!important;">
            <div class="uk-card-media-top uk-text-center uk-padding-small">
              <div class="uk-animation-toggle" tabindex="0">
                <img class="uk-animation-slide-top-small" src="assets/homefb.jpg" width="40%" height="40%" alt="">
              </div>
            </div>
            <div class="uk-card-body">
              <h4 class="uk-card-title uk-text-center">Facebook Marketing Services</h4>
              <p class="uk-text-left ">Facebook promotion is very broad and you can spread the phrase on a wider scale
                with this. We develop the content, visual and targeted users.</p>

            </div>
          </div>
        </div>
        <div>
          <div class="uk-card uk-card-small"
            style="box-shadow: 0 .125rem .25rem rgba(0,0,0,.075)!important; border: 1px solid #dee2e6!important;">
            <div class="uk-card-media-top uk-text-center uk-padding-small">
              <div class="uk-animation-toggle" tabindex="0">
                <img class="uk-animation-slide-top-small" src="assets/hometw.png" width="40%" height="40%" alt="">
              </div>
            </div>
            <div class="uk-card-body">
              <h4 class="uk-card-title uk-text-center">Twitter Marketing Services</h4>
              <p class="uk-text-left">Compared to other modes of digital marketing, the Twitter marketing service
                promotion has the advantage of being a quick conversion. </p>

            </div>
          </div>
        </div>
        <div>
          <div class="uk-card uk-card-small"
            style="box-shadow: 0 .125rem .25rem rgba(0,0,0,.075)!important; border: 1px solid #dee2e6!important;">
            <div class="uk-card-media-top uk-text-center uk-padding-small">
              <div class="uk-animation-toggle" tabindex="0">
                <img class="uk-animation-slide-top-small" src="assets/homein.webp" width="40%" height="40%" alt="">
              </div>
            </div>
            <div class="uk-card-body">
              <h4 class="uk-card-title uk-text-center">LinkedIn Marketing Services</h4>
              <p class="uk-text-left">LinkedIn is the most believed strategy to provide the right path to your business
                missions. It’s a direction to create connections with influencers.</p>

            </div>
          </div>
        </div>
        <div>
          <div class="uk-card uk-card-small"
            style="box-shadow: 0 .125rem .25rem rgba(0,0,0,.075)!important; border: 1px solid #dee2e6!important;">
            <div class="uk-card-media-top uk-text-center uk-padding-small">
              <div class="uk-animation-toggle" tabindex="0">
                <img class="uk-animation-slide-top-small" src="assets/homeinsta.jpg" width="40%" height="40%" alt="">
              </div>
            </div>
            <div class="uk-card-body">
              <h4 class="uk-card-title uk-text-center">Instagram Marketing Services</h4>
              <p class="uk-text-left">Instagram marketing is the most significant part of online communications and
                media assigned to community-based input, interaction.</p>

            </div>
          </div>
        </div>
        <div>
          <div class="uk-card uk-card-small"
            style="box-shadow: 0 .125rem .25rem rgba(0,0,0,.075)!important; border: 1px solid #dee2e6!important;">
            <div class="uk-card-media-top uk-text-center uk-padding-small">
              <div class="uk-animation-toggle" tabindex="0">
                <img class="uk-animation-slide-top-small" src="assets/homepin.png" width="40%" height="40%" alt="">
              </div>
            </div>
            <div class="uk-card-body">
              <h4 class="uk-card-title uk-text-center">Pinterest Marketing Services</h4>
              <p class="uk-text-left">Pinterest is an incredibly valuable resource and an efficient platform for
                businesses and clients. With the increasing importance of visual marketing. </p>

            </div>
          </div>
        </div>
        <div>
          <div class="uk-card uk-card-small"
            style="box-shadow: 0 .125rem .25rem rgba(0,0,0,.075)!important; border: 1px solid #dee2e6!important;">
            <div class="uk-card-media-top uk-text-center uk-padding-small">
              <div class="uk-animation-toggle" tabindex="0">
                <img class="uk-animation-slide-top-small" src="assets/homegoogle.png" width="40%" height="40%" alt="">
              </div>
            </div>
            <div class="uk-card-body">
              <h4 class="uk-card-title uk-text-center">Google Marketing Services</h4>
              <p class="uk-text-left">It enables you to show your ads on Google’s partner websites. Google has millions
                of sites and shows ads enable you to spot your ads on sites.</p>

            </div>
          </div>
        </div>
        <div>
          <div class="uk-card uk-card-small"
            style="box-shadow: 0 .125rem .25rem rgba(0,0,0,.075)!important; border: 1px solid #dee2e6!important;">
            <div class="uk-card-media-top uk-text-center uk-padding-small">
              <div class="uk-animation-toggle" tabindex="0">
                <img class="uk-animation-slide-top-small" src="assets/homead.png" width="40%" height="40%" alt="">
              </div>
            </div>
            <div class="uk-card-body">
              <h4 class="uk-card-title uk-text-center">Adwords Marketing Services</h4>
              <p class="uk-text-left">Adwords is an incredibly significant marketing tool, but it can do more harm than
                useful if spotted in unskilled hands. Our squad of knowledgable. </p>

            </div>
          </div>
        </div>
        <div>
          <div class="uk-card uk-card-small"
            style="box-shadow: 0 .125rem .25rem rgba(0,0,0,.075)!important; border: 1px solid #dee2e6!important;">
            <div class="uk-card-media-top uk-text-center uk-padding-small">
              <div class="uk-animation-toggle" tabindex="0">
                <img class="uk-animation-slide-top-small" src="assets/homeyoutube.png" width="40%" height="40%" alt="">
              </div>
            </div>
            <div class="uk-card-body">
              <h4 class="uk-card-title uk-text-center">YouTube Marketing Service</h4>
              <p class="uk-text-left">WebSoulLabs, a premiere YouTube marketing company based in India, delivers
                specialist outsourced services in YouTube marketing. </p>

            </div>
          </div>
        </div>
      </div>
    </li>
  </ul>
</div>





<!--end of tab-->
